export const handleFundingOrgsHelper = (selectedOption) => {
  const extractedInfo = selectedOption.map((item) => {
    const match = item.value.match(/^\d+-(a|b)-(.+)$/);
    return match ? { belongsTo: match[1], finalString: match[2] } : null;
  });

  let parentic = [];
  let primaryic = [];

  extractedInfo.forEach((info) => {
    if (info) {
      if (info.belongsTo === "a") {
        parentic.push(info.finalString);
      } else if (info.belongsTo === "b") {
        primaryic.push(info.finalString);
      }
    }
  });

  let updateDataQuery = {
    parentic: parentic.length > 0 ? parentic.join(",") : "all",
    primaryic: primaryic.length > 0 ? primaryic.join(",") : "all",
  };
  return updateDataQuery;
};
